var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4749 4.44337V3.05421C13.4749 2.68578 13.3285 2.33244 13.068 2.07192C12.8075 1.8114 12.4542 1.66504 12.0857 1.66504H7.91824C7.54981 1.66504 7.19647 1.8114 6.93595 2.07192C6.67543 2.33244 6.52907 2.68578 6.52907 3.05421V4.44337H3.05615V5.83254H4.44532V16.2513C4.44532 16.8039 4.66486 17.3339 5.05564 17.7247C5.44641 18.1155 5.97642 18.335 6.52907 18.335H13.4749C14.0275 18.335 14.5576 18.1155 14.9483 17.7247C15.3391 17.3339 15.5587 16.8039 15.5587 16.2513V5.83254H16.9478V4.44337H13.4749ZM9.3074 13.473H7.91824V9.30546H9.3074V13.473ZM12.0857 13.473H10.6966V9.30546H12.0857V13.473ZM12.0857 4.44337H7.91824V3.05421H12.0857V4.44337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cdc98cf600ddb6eebcb70f68d8ab2405.svg";
export { ForwardRef as ReactComponent };